import React from 'react';
import { useAxiosWithAuthentication, useAxiosWithCurrentLanguage } from '../cp-xhr';

export const AxiosConfiguration: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    useAxiosWithCurrentLanguage();
    useAxiosWithAuthentication();
    return <>{children}</>;
};
